
window.theme = window.theme || {};

$.fn.safeOffset = function() { 
  return this.offset() || {
    top: 0,
    left: 0 
  }
};
$.fn.safeWidth = function(n) { 
  return this.width() || (n !== undefined ? n : 0)
};
$.fn.safeHeight = function(n) {
  return parseInt(this.height()) || (n !== undefined ? n : 0)
};
$.fn.safeOuterWidth = function(n) {
  return this.outerWidth() || (n !== undefined ? n : 0)
};
$.fn.safeOuterHeight = function(n) {
  return this.outerHeight() || (n !== undefined ? n : 0)
}


setInterval(function(){
	if( $("#wizard-t-1").parent().hasClass("current")){
		if($("#Width-inches").val() == '0' || $("#Height-inches").val() == '0'){
			$(".calc_price").hide();
			$(".base_price").show();
			$('a[href="#next"]').css('pointer-events','none');
			$('a[href="#next"]').css('opacity','0.3');
		}else{
			$(".calc_price").show();
			$(".base_price").hide();
			$('a[href="#next"]').css('pointer-events','visible');
		   $('a[href="#next"]').css('opacity','1');
		}
	}
},500);	 

function initializeRulers(n) {
    $("." + n +" .ruler").each(function() {
        var t = $(this).data("type"),
            n = getInchOptionValues(t);
        buildRuler($(this), n);
        setStartingPoint($(this), n)
    });
    initializeDrag()
}

function initializeDrag() {
    $(".draggableRulerSlider").length > 0 && $(".draggableRulerSlider").draggable({
        axis: "x",
        containment: "parent",
        drag: drag,
        start: function() {
            var n = $(this),
                t = n.parents(".draggableRulerSliderContainer").siblings(".rulerContainer").find(".ruler");
            initializeDrop(t)
        },
        stop: function() {
            rulerMoving && stopRulerMoving()
        }
    })
}

function initializeDrop(n) {
    n.find(".quarter").droppable({
        drop: function() {
            var t = n.data("type");
            rebuild8thsIfDisabled(t);
            if($(this).hasClass("droppable")) {
              $("#" + t + "-inches").val($(this).data("inch"));
              $("#" + t + "-quarters").val($(this).data("quarter")).change()
            } else {
              $("#" + t + "-inches").val($(this).data("inch"));
              if($(this).next().data("quarter")) {
                 $("#" + t + "-quarters").val($(this).next().data("quarter")).change()   
              } else {
                $("#" + t + "-quarters").val("0").change()   
              }          
            }
        }
    })
}

function drag(n, t) {
    var r = $(this).parents(".draggableRulerSliderContainer").siblings(".rulerContainer").find(".ruler"),
        e = r.parent().safeWidth(),
        h = r.safeWidth(),
        c = t.position.left + $(this).safeWidth(),
        i = c / e,
        u = !1,
        f, o = .2,
        s = .9;
    i > s || i < o ? u = !0 : (u = !1, stopRulerMoving());
    !rulerMoving && u && (i > s && (f = h - e + "px"), i < o && (f = "0px"), r.animate({
        right: f
    }, 5e3), rulerMoving = !0)
}

function stopRulerMoving() {
    $(".ruler").length > 0 && ($(".ruler").stop(), rulerMoving = !1)
}

function buildRuler(n, t) {
    var r = n.data("type"),
        u = Math.min.apply(Math, t),
        i = Math.max.apply(Math, t),
        e = parseInt($("#" + r + "-inches").val()),
        f;
    e === i && $("#" + r + "-quarters").find("option:enabled").length > 1 && (i = i + 1);
    f = i - u;
    n.append(getRulerUI(u, i));
    n.css({
        width: f * n.find(".inchContainer").safeWidth() + n.find(".quarter .inchNumber").safeWidth() + 25 + "px",
        "padding-left": "5%"
    }) 
  /* Adjust padding-left according to max width of ruler box */
}

function getRulerUI(n, t) {
    var u = "",
        f, h, c;
    for (i = n - 1; i < t; i++)
        if (u += '<div class="inchContainer">', i < t) {
            for (e = 0; e < 9; e++) {
                var r = '<div class="quarter',
                    o = "",
                    s = "measurement ";
                e < 8 && (f = e / 8, f == 0 ? (r += ' inch droppable" ', o = '<span class="inchNumber">' + (f == 0 ? i + 1 : "") + "<\/span>") : e == 2 || e == 4 || e == 6 ? (e == 4 ? (r += ' forth half droppable" ', s += "halfNumber", h = "1/2") : (r += ' forth droppable" ', s += "forthNumber", h = e / 2 + "/4"), o = '<span class="' + s + '">' + h + "<\/span>") : r += '" ', r += 'data-inch="' + (i + 1) + '" data-quarter="' + f + '">', r += '<span class="mark"><\/span>' + o + "<\/div>", u += r)
            }
            u += "<\/div>"
        } else c = '<div class="quarter inch droppable" ', c += 'data-inch="' + t + '" data-quarter="0"><span class="mark"><\/span><span class="inchNumber">' + t + "<\/span><\/div>", u += c;
    return u
}

function setStartingPoint(n, t) {
    var u = n.data("type"),
        r = parseInt($("#" + u + "-inches").val()),
        f = parseFloat($("#" + u + "-quarters").val()),
        i;
    if (r === 0 && (r = Math.min.apply(Math, t), f = 0), i = n.find(".inchContainer").find('[data-inch="' + r + '"][data-quarter="' + f + '"]'), i.length > 0) {
        var e = n.parents(".rulerSliderContainer"),
            o = e.find(".draggableRulerSlider"),
            s = e.find(".draggableRulerSliderContainer"),
            h = i.position().left + i.find(".mark").safeWidth() - o.position().left / s.safeWidth() * n.parent().safeWidth() - o.safeWidth() * .45;
        n.css("right", h)
    }
}

function getInchOptionValues(n) {
    var t = [];
    return $("#" + n + "-inches option:not([disabled])").each(function() {
        var n = parseInt($(this).val());
        !isNaN(n) && n > 0 && t.push(n)
    }), t
}

function rebuild8thsIfDisabled(n) {
    var t = $("#" + n + "-quarters[disabled]"),
        i;
    t.length > 0 && (t.prop("disabled", !1), t.html(get8thOptionValues()));
    i = $("#" + n + "-quarters").find("option[disabled]");
    i.length > 0 && $("#" + n + "-quarters").find("option[disabled]").prop("disabled", !1)
}

function get8thOptionValues() {
    var n = '<option value="0">0<\/option>';
    return n += '<option value="0.25">1/4<\/option>', n += ' <option value="0.5">1/2<\/option>', n += '<option value="0.75">3/4<\/option>'
}

var rulerMoving = !1;

$('#wizard').steps({
  labels: {
      finish: "Order" 
  },
  onInit: function() {
    $(this).show();
    generatePrice();
  },
  onStepChanged: function() {
    $(".ruler").length > 0 && ($(".ruler").html(""), initializeRulers("ruler-wrap"));
    $(".ruler").length > 0 && ($(".ruler").html(""), initializeRulers("ruler-wrap"));
    
    $('.wizardPrice')[0].scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  },
  onStepChanging: function (event, currentIndex, newIndex)
  {
    //     if (currentIndex === 0 || currentIndex === 1 || currentIndex === 4) {
    //       return true;
    //     }

    //     return $('#wizard-p-'+currentIndex).find('input[type="radio"]').is(':checked')
    //     New change starts
	  var $doorType      = $('#doorType');
	  var $p_id      = $('#p_id').val();
	  console.log("$p_id "+$p_id);
	 if ($doorType.val() === 'barn-double-door' || $doorType.val() === 'barn-door' || $doorType.val() === 'pocket-door1' ) {
		if (currentIndex === 1 || currentIndex === 3) {
		  return true;
		}
	 }else if ($doorType.val() === 'single door') {
		 if (currentIndex === 1 || currentIndex === 5) {
		  return true;
		}
	 }else{
		 if( $p_id == '8388498325810' ||  $p_id == '8398933918002' ){
			 
			 if (currentIndex === 1 || currentIndex === 5) {
			  return true;
			}
		 }else{
			  if (currentIndex === 1 || currentIndex === 3) {
			  return true;
			}
		 }
	 }
    if (currentIndex === 0) { 
      return  $('.room_name').val().length != 0 
    } else { 
	
      return $('#wizard-p-'+currentIndex).find('input[type="radio"]').is(':checked')
    }
    //     New change ends
    
  },
  onFinished: function (event, currentIndex)
  {
    addToCart();
  }
}); 

$(".ruler--input").on("change", function() {
  $(".ruler").length > 0 && ($(".ruler").html(""), initializeRulers("ruler-wrap"));
});

$(window).on("resize", function() {
  setTimeout(function() {
    $(".ruler").length > 0 && ($(".ruler").html(""), initializeRulers("ruler-wrap"));
  }, 300);
});

$(function() {
    $(".ruler").length > 0 && ($(".ruler").html(""), initializeRulers("ruler-wrap"));
});

$("#wizard").on('change','input, select', function(){
  generatePrice();
});

$("#menuitem").click(function(){
  generatePrice();
});


$('#wizard').on('click', 'a[href="#finish"]', function() {
  $('.wizardPrice')[0].scrollIntoView({
    behavior: 'smooth',
    block: 'nearest',
    inline: 'start'
  });
});

var $widthInSlab = $('#Width-inches-slab');
var $widthQtSlab = $('#Width-quarters-slab');
var $widthInSlabB = $('#Width-inches-slab-b');
var $widthQtSlabB = $('#Width-quarters-slab-b');
var $widthInRo = $('#Width-inches');
var $widthQtRo = $('#Width-quarters');
var $heightInSlab = $('#Height-inches-slab');
var $heightQtSlab = $('#Height-quarters-slab');
var $heightInRo = $('#Height-inches');
var $heightQtRo = $('#Height-quarters');


var $widthInSlab1 = $('#Width-clearinches');
var $widthQtSlab1 = $('#Width-clearquarters');

var $heightInSlab1 = $('#Height-inches-slab1');
var $heightQtSlab1 = $('#Height-quarters-slab1');
var $heightInRo1 = $('#Height-inches1');
var $heightQtRo1 = $('#Height-quarters1');

/*
* Listen to changes and direct to correct function
*/
$(document).ready(function(){
	var measurement = $("#Width-inches").data('measurement');
	var measurement1 = $("#Height-inches").data('measurement');
	console.log(measurement);
	console.log(measurement1);
	disableQuarterCheck();
	if (measurement === 'Width-slab-single') slabWidthMeasurementSingle();
	if (measurement === 'Width-ro-single') roWidthMeasurementSingle();
	if (measurement1 === 'Height-slab-single') slabHeightMeasurement();
	if (measurement1 === 'Height-ro-single') roHeightMeasurement();
	
	if (measurement1 === 'Height-slab-double-pocket-door') slabHeightMeasurementDoublePocketDoor();
	if (measurement1 === 'Height-ro-double-pocket-door') roHeightMeasurementDoublePocketDoor();
	if (measurement1 === 'Height-slab-double-pocket-door1') slabHeightMeasurementDoublePocketDoor1();
	if (measurement1 === 'Height-ro-double-pocket-door1') roHeightMeasurementDoublePocketDoor1();
	if (measurement === 'Width-slab-double-pocket-door') slabWidthMeasurementDoublePocketDoor();
	if (measurement === 'Width-ro-double-pocket-door') roWidthMeasurementDoublePocketDoor();
	
	
	if (measurement1 === 'Height-slab-pocket-door') slabHeightMeasurementPocketDoor();
	if (measurement1 === 'Height-ro-pocket-door') roHeightMeasurementPocketDoor();
	if (measurement1 === 'Height-slab-pocket-door1') slabHeightMeasurementPocketDoor1();
	if (measurement1 === 'Height-ro-pocket-door1') roHeightMeasurementPocketDoor1();
	if (measurement === 'Width-slab-pocket-door') slabWidthMeasurementPocketDoor();
	if (measurement === 'Width-ro-pocket-door') roWidthMeasurementPocketDoor();
	
	if (measurement === 'Width-slab-pivot') slabWidthMeasurementPivot();
	if (measurement === 'Width-ro-pivot') roWidthMeasurementPivot();
	if (measurement1 === 'Height-slab-pivot') slabHeightMeasurementPivot();
	if (measurement1 === 'Height-ro-pivot') roHeightMeasurementPivot();
	
	if (measurement === 'Width-slab-twodoor') slabWidthMeasurementSingle();
	if (measurement === 'Width-ro-twodoor') roWidthMeasurementSingle();
	if (measurement1 === 'Height-slab-twodoor') slabHeightMeasurement();
	if (measurement1 === 'Height-ro-twodoor') roHeightMeasurement();
	
	if (measurement === 'Width-slab-double') slabWidthMeasurementDouble();
	if (measurement === 'Width-ro-double') roWidthMeasurementDouble();
	
	if (measurement === 'Width-slab-bifold') slabWidthMeasurementbifold();
	if (measurement === 'Width-ro-bifold') roWidthMeasurementbifold();
	if (measurement1 === 'Height-slab-bifold') slabHeightMeasurementbifold();
	if (measurement1 === 'Height-ro-bifold') roHeightMeasurementbifold();
	
	if (measurement === 'Width-slab-3bifold') slabWidthMeasurement3bifold();
	if (measurement === 'Width-ro-3bifold') roWidthMeasurement3bifold();
	if (measurement1 === 'Height-slab-3bifold') slabHeightMeasurement3bifold();
	if (measurement1 === 'Height-ro-3bifold') roHeightMeasurement3bifold();
	
	if (measurement === 'Width-slab-4bifold') slabWidthMeasurement4bifold();
	if (measurement === 'Width-ro-4bifold') roWidthMeasurement4bifold();
	if (measurement1 === 'Height-slab-4bifold') slabHeightMeasurement4bifold();
	if (measurement1 === 'Height-ro-4bifold') roHeightMeasurement4bifold();
	
	if (measurement === 'Width-slab-barn-double') slabWidthMeasurementBarnDouble();
	if (measurement === 'Width-ro-barn-double') roWidthMeasurementBarnDouble();
	if (measurement1 === 'Height-slab-barn-double') slabHeightMeasurementBarnDouble();
	if (measurement1 === 'Height-ro-barn-double') roHeightMeasurementBarnDouble();
	
	if (measurement === 'Width-slab-barn') slabWidthMeasurementBarn();
	if (measurement === 'Width-ro-barn') roWidthMeasurementBarn();
	if (measurement === 'Height-slab-barn') slabHeightMeasurementBarn();
	if (measurement === 'Height-ro-barn') roHeightMeasurementBarn();
	
	
	disableQuarterCheck();
});

$("#wizard").on('change','.configMeasurement select', function() {
	var measurement = $(this).data('measurement');
	console.log(measurement);
	disableQuarterCheck(); 
	
	if (measurement === 'Width-slab-pocket-door') slabWidthMeasurementPocketDoor();
	if (measurement === 'Width-ro-pocket-door') roWidthMeasurementPocketDoor();
	
	if (measurement === 'Width-slab-double-pocket-door') slabWidthMeasurementDoublePocketDoor();
	if (measurement === 'Width-ro-double-pocket-door') roWidthMeasurementDoublePocketDoor();
	
	if (measurement === 'Width-slab-single') slabWidthMeasurementSingle();
	if (measurement === 'Width-ro-single') roWidthMeasurementSingle();
	
	if (measurement === 'Width-slab-pivot') slabWidthMeasurementPivot();
	if (measurement === 'Width-ro-pivot') roWidthMeasurementPivot();
	
	
	if (measurement === 'Width-slab-twodoor') slabWidthMeasurementSingle();
	if (measurement === 'Width-ro-twodoor') roWidthMeasurementSingle();
	
	
	if (measurement === 'Width-slab-double') slabWidthMeasurementDouble();
	if (measurement === 'Width-ro-double') roWidthMeasurementDouble();
	
	if (measurement === 'Width-slab-bifold') slabWidthMeasurementbifold();
	if (measurement === 'Width-ro-bifold') roWidthMeasurementbifold();
	
	
	if (measurement === 'Width-slab-3bifold') slabWidthMeasurement3bifold();
	if (measurement === 'Width-ro-3bifold') roWidthMeasurement3bifold();
	
	
	if (measurement === 'Width-slab-4bifold') slabWidthMeasurement4bifold();
	if (measurement === 'Width-ro-4bifold') roWidthMeasurement4bifold();
	
	
	if (measurement === 'Height-slab-single') slabHeightMeasurement();
	if (measurement === 'Height-ro-single') roHeightMeasurement();
	
	if (measurement === 'Height-slab-pocket-door') slabHeightMeasurementPocketDoor();
	if (measurement === 'Height-ro-pocket-door') roHeightMeasurementPocketDoor();
	if (measurement === 'Height-slab-pocket-door1') slabHeightMeasurementPocketDoor1();
	if (measurement === 'Height-ro-pocket-door1') roHeightMeasurementPocketDoor1();
	
	
	if (measurement === 'Height-slab-double-pocket-door') slabHeightMeasurementDoublePocketDoor();
	if (measurement === 'Height-ro-double-pocket-door') roHeightMeasurementDoublePocketDoor();
	if (measurement === 'Height-slab-double-pocket-door1') slabHeightMeasurementDoublePocketDoor1();
	if (measurement === 'Height-ro-double-pocket-door1') roHeightMeasurementDoublePocketDoor1();
	
	
	if (measurement === 'Height-slab-pivot') slabHeightMeasurementPivot();
	if (measurement === 'Height-ro-pivot') roHeightMeasurementPivot();

	if (measurement === 'Height-slab-twodoor') slabHeightMeasurement();
	if (measurement === 'Height-ro-twodoor') roHeightMeasurement();
	
	if (measurement === 'Height-slab-bifold') slabHeightMeasurementbifold();
	if (measurement === 'Height-ro-bifold') roHeightMeasurementbifold();
	
	if (measurement === 'Height-slab-3bifold') slabHeightMeasurement3bifold();
	if (measurement === 'Height-ro-3bifold') roHeightMeasurement3bifold();
	
	if (measurement === 'Height-slab-4bifold') slabHeightMeasurement4bifold();
	if (measurement === 'Height-ro-4bifold') roHeightMeasurement4bifold();
	
	
	if (measurement === 'Width-slab-barn-double') slabWidthMeasurementBarnDouble();
	if (measurement === 'Width-ro-barn-double') roWidthMeasurementBarnDouble();
	if (measurement === 'Height-slab-barn-double') slabHeightMeasurementBarnDouble();
	if (measurement === 'Height-ro-barn-double') roHeightMeasurementBarnDouble();
	
	
	if (measurement === 'Width-slab-barn') slabWidthMeasurementBarn();
	if (measurement === 'Width-ro-barn') roWidthMeasurementBarn();
	if (measurement === 'Height-slab-barn') slabHeightMeasurementBarn();
	if (measurement === 'Height-ro-barn') roHeightMeasurementBarn();

	
	disableQuarterCheck();
});


/*
* Double Door
* Copies values between slab select boxes
*/
$widthInSlab.on('change', function() {
  //alert($widthInSlab.val());
  $widthInSlabB.val($widthInSlab.val());
});

$widthInSlabB.on('change', function() {
  $widthInSlab.val($widthInSlabB.val());
});

$widthQtSlab.on('change', function() {
  $widthQtSlabB.val($widthQtSlab.val());
});

$widthQtSlabB.on('change', function() {
  $widthQtSlab.val($widthQtSlabB.val());
});


/*
* Double Door
* Converts Slab Width to Rough Opening Width
*/
function slabWidthMeasurementDouble() {
  var slabA = parseInt($widthInSlab.val()) + parseFloat($widthQtSlab.val());
  var slabB = parseInt($widthInSlabB.val()) + parseFloat($widthQtSlabB.val())
  
  var slabDimensions = slabA + slabB;
  var roDimensions = (slabDimensions + 3);
        
  $widthInRo.val(Math.floor(roDimensions)).trigger('change');
  $widthQtRo.val(roDimensions % 1).trigger('change');
}


/*
* Double Door
* Converts Rogth Opening Width to Slab Width
*/
function roWidthMeasurementDouble() {
  var roDimensions = parseInt($widthInRo.val()) + parseFloat($widthQtRo.val());
  var slabDimensions = (roDimensions - 2) / 2;
  console.log(slabDimensions);
  $widthInSlab.val(Math.floor(slabDimensions));
  $widthQtSlab.val(slabDimensions % 1);
  $widthInSlabB.val(Math.floor(slabDimensions));
  $widthQtSlabB.val(slabDimensions % 1);
}

/*
* Double Door Bi Fold
* Converts Rogth Opening Width to Slab Width
*/
function roWidthMeasurementbifold() {
  var roDimensions = parseInt($widthInRo.val()) + parseFloat($widthQtRo.val());
  var slabDimensions = (roDimensions - 2) / 2;
  //  alert(slabDimensions);
  $widthInSlab.val(Math.floor(slabDimensions));
  $widthQtSlab.val(slabDimensions % 1);
  $widthInSlabB.val(Math.floor(slabDimensions));
  $widthQtSlabB.val(slabDimensions % 1);
}


/*
* Double Door 3-Bi Fold
* Converts Rogth Opening Width to Slab Width
*/

function roWidthMeasurement3bifold() {
  var roDimensions = parseInt($widthInRo.val()) + parseFloat($widthQtRo.val());
  var slabDimensions = (roDimensions - 2) / 3;
  var vv = getWidth(slabDimensions);
 
  $widthInSlab.val(Math.floor(slabDimensions));
  $widthQtSlab.val(vv % 1);
  $widthInSlabB.val(Math.floor(slabDimensions));
  $widthQtSlabB.val(vv % 1);
}


/*
* Double Door 4-Bi Fold
* Converts Rogth Opening Width to Slab Width
*/
function roWidthMeasurement4bifold() {
  var roDimensions = parseInt($widthInRo.val()) + parseFloat($widthQtRo.val());
  var slabDimensions = (roDimensions - 2) / 4;
  var vv = getWidth(slabDimensions);
  $widthInSlab.val(Math.floor(slabDimensions));
  $widthQtSlab.val(vv % 1);
  $widthInSlabB.val(Math.floor(slabDimensions));
  $widthQtSlabB.val(vv % 1);
}

/*
* Barn Door
* Converts Rogth Opening Width to Slab Width
*/
function roWidthMeasurementBarn() {
  var roDimensions = parseInt($widthInRo.val()) + parseFloat($widthQtRo.val());
  var slabDimensions = (roDimensions + 8);
  console.log(slabDimensions);
  var vv = getWidth(slabDimensions);
  $widthInSlab.val(Math.floor(slabDimensions));
  $widthQtSlab.val(vv % 1);
}

/*
* Barn Double Door
* Converts Rogth Opening Width to Slab Width
*/
function roWidthMeasurementBarnDouble() {
  var roDimensions = parseInt($widthInRo.val()) + parseFloat($widthQtRo.val());
  var slabDimensions = (roDimensions + 14) / 2;
  console.log(slabDimensions);
  var vv = getWidth(slabDimensions);
  $widthInSlab.val(Math.floor(slabDimensions));
  $widthQtSlab.val(vv % 1);
}


/*
* Converts Slab Width to Rough Opening Width
*/
function slabWidthMeasurementDoublePocketDoor() {
	if($widthInSlab.val() == 0){
	  $widthInRo.val(0);
	  $widthQtRo.val(0);
	  $widthInSlab1.val(0);
	  $widthQtSlab1.val(0);
	}else{
	  var slabDimensions = parseInt($widthInSlab.val()) + parseFloat($widthQtSlab.val());
	  var roDimensions = (slabDimensions - 1.75) * 4 + 10;
	  if(roDimensions<48){
		  roDimensions = 48;
	  }
	 // console.log("roDimensions" + roDimensions);
	  $widthInRo.val(Math.floor(roDimensions)).trigger("change");
	  var vv = getWidth(roDimensions);
	  $widthQtRo.val(vv % 1).trigger("change");

	  var roDimensions1 = (((roDimensions - 10) / 2)+1.25);
	  var vv = getWidth(roDimensions1);
	  $widthInSlab1.val(Math.floor(roDimensions1));
	  $widthQtSlab1.val(vv % 1);
	}
  
}



/*
* Converts Slab Width to Rough Opening Width
*/
function slabWidthMeasurementPocketDoor() {
	if($widthInSlab.val() == 0){
		$widthInRo.val(0);
		$widthQtRo.val(0);
		$widthInSlab1.val(0);
		$widthQtSlab1.val(0);
	}else{
	  var slabDimensions = parseInt($widthInSlab.val()) + parseFloat($widthQtSlab.val());
	  //alert(slabDimensions)
	  // var roDimensions = (slabDimensions - 1.75) * 2 + 5;
	  // var roDimensions1 = slabDimensions - 1.75;
	
	  var roDimensions = (slabDimensions*2)+2.75 ;
	  var roDimensions1 = (slabDimensions - 1.125);
	  if (roDimensions < 36){
        roDimensions = 36;
      }
	 // console.log("roDimensions" + slabDimensions);
	 $widthInRo.val(Math.floor(roDimensions)).trigger("change");
	  $widthQtRo.val(roDimensions % 1).trigger("change");
	  var v = getClearOpending(slabDimensions);
	  var vv = getWidth(roDimensions1);
	  $widthInSlab1.val(Math.floor(roDimensions1));
	  $widthQtSlab1.val(vv % 1);
	}
  
}

/*
* Converts Slab Width to Rough Opening Width
*/
function slabWidthMeasurementSingle() {
  var slabDimensions = parseInt($widthInSlab.val()) + parseFloat($widthQtSlab.val());
  var roDimensions = (slabDimensions + 3);
       
  $widthInRo.val(Math.floor(roDimensions)).trigger('change');
  $widthQtRo.val(roDimensions % 1).trigger('change');
}


/*
* Converts Slab Width to Rough Opening Width
*/
function slabWidthMeasurementPivot() {
  var slabDimensions = parseInt($widthInSlab.val()) + parseFloat($widthQtSlab.val());
  var roDimensions = (slabDimensions + 3);
       
  $widthInRo.val(Math.floor(roDimensions)).trigger('change');
  $widthQtRo.val(roDimensions % 1).trigger('change');
}




/*
* Double Door 3-Bi Fold
*/
function slabWidthMeasurement3bifold() {
  var slabDimensions = parseFloat($widthInSlab.val()) + parseFloat($widthQtSlab.val());
  var roDimensions = ((slabDimensions * 3)+2);
  $widthInRo.val(Math.floor(roDimensions));
  var vv = getRoWidth(roDimensions);

  $widthQtRo.val(vv);
}


/*
*  Double Door 4-Bi Fold
*/
function slabWidthMeasurement4bifold() {
  var slabDimensions = parseInt($widthInSlab.val()) + parseFloat($widthQtSlab.val());
  var roDimensions = ((slabDimensions * 4)+2);  
  //console.log(roDimensions);
  // $widthInRo.val(Math.floor(roDimensions)).trigger('change');
  // var vv = getRoWidth(roDimensions);
  // $widthQtRo.val(vv).trigger('change');
  
   $widthInRo.val(Math.floor(roDimensions));
  var vv = getRoWidth(roDimensions);
  $widthQtRo.val(vv);
}


/*
*   Barn Door
*/
function slabWidthMeasurementBarn() {
  var slabDimensions = parseInt($widthInSlab.val()) + parseFloat($widthQtSlab.val());
  var roDimensions = ((slabDimensions)-8);  
  
   $widthInRo.val(Math.floor(roDimensions));
  var vv = getRoWidth(roDimensions);
  $widthQtRo.val(vv);
}


/*
*   Barn Double Door
*/
function slabWidthMeasurementBarnDouble() {
  var slabDimensions = parseInt($widthInSlab.val()) + parseFloat($widthQtSlab.val());
  var roDimensions = ((slabDimensions * 2)-14);  
  
   $widthInRo.val(Math.floor(roDimensions));
  var vv = getRoWidth(roDimensions);
  $widthQtRo.val(vv);
}


/*
* Converts Slab Width to Rough Opening Width
*/
function slabWidthMeasurementbifold() {
  var slabDimensions = parseInt($widthInSlab.val()) + parseFloat($widthQtSlab.val());
  var roDimensions = ((slabDimensions *2 )+2);
  
  $widthInRo.val(Math.floor(roDimensions));
  var vv = getRoWidth(roDimensions);
  $widthQtRo.val(vv);
}


/* 
* Converts Rough Opening Width to Slab Width
*/
function roWidthMeasurementPocketDoor() {
  /*var roDimensions = parseInt($widthInRo.val()) + parseFloat($widthQtRo.val());
  var slabDimensions = (((roDimensions-5)/2));
  var slabDimensions1 = (slabDimensions+1.75);
  $widthInSlab.val(Math.floor(slabDimensions1));
  $widthQtSlab.val(slabDimensions1 % 1);
  
  var v = getClearOpending(slabDimensions);
  var vv = getWidth(slabDimensions);
  $widthInSlab1.val(Math.floor(slabDimensions));
  $widthQtSlab1.val(vv % 1);*/
  
  
  if($widthInRo.val() == 0){
	  $widthInSlab.val(0);
	  $widthQtSlab.val(0);
	  $widthInSlab1.val(0);
	  $widthQtSlab1.val(0);
	}else{
	  var roDimensions = parseInt($widthInRo.val()) + parseFloat($widthQtRo.val());
      console.log(roDimensions);
	  // var slabDimensions = (roDimensions - 5) / 2;
	  // var slabDimensions1 = slabDimensions + 1.75;
	  var slabDimensions = (roDimensions - 2.75)/2 ;
	  //alert(slabDimensions)
	  var slabDimensions1 = (slabDimensions - 1.125);
	  $widthInSlab.val(Math.floor(slabDimensions));
	  $widthQtSlab.val(slabDimensions % 1);

	  var vv = getWidth(slabDimensions1);
	  $widthInSlab1.val(Math.floor(slabDimensions1));
	  $widthQtSlab1.val(vv % 1);
	}
  
}

/* 
* Converts Rough Opening Width to Slab Width
*/
function roWidthMeasurementDoublePocketDoor() {
	if($widthInRo.val() == 0){
	  $widthInSlab.val(0);
	  $widthQtSlab.val(0);
	  $widthInSlab1.val(0);
	  $widthQtSlab1.val(0);
	}else{
		var roDimensions = parseInt($widthInRo.val()) + parseFloat($widthQtRo.val());
	  var slabDimensions = (roDimensions - 10) / 4;
	  var slabDimensions1 = slabDimensions + 1.75;
	  var vv = getWidth(slabDimensions1);
	  $widthInSlab.val(Math.floor(slabDimensions1));
	  $widthQtSlab.val(slabDimensions1 % 1);
	  var slabDimensions = (((roDimensions - 10) / 2)+1.25);
	  // alert(slabDimensions)
	  var vv = getWidth(slabDimensions);
	  $widthInSlab1.val(Math.floor(slabDimensions));
	  $widthQtSlab1.val(vv % 1);
	}
  
}

/*
* Converts Rough Opening Width to Slab Width
*/
function roWidthMeasurementSingle() {
  var roDimensions = parseInt($widthInRo.val()) + parseFloat($widthQtRo.val());
  var slabDimensions = (roDimensions - 3);
  $widthInSlab.val(Math.floor(slabDimensions));
  $widthQtSlab.val(slabDimensions % 1);
}


/*
* Converts Rough Opening Width to Slab Width
*/
function roWidthMeasurementPivot() {
  var roDimensions = parseInt($widthInRo.val()) + parseFloat($widthQtRo.val());
  var slabDimensions = (roDimensions - 3);
  $widthInSlab.val(Math.floor(slabDimensions));
  $widthQtSlab.val(slabDimensions % 1);
}

/*
**
Bi-fold door convert ro width to slab 
*/
function roWidthMeasurementTwodoor() {
 
   var widthInches = $("#Width-inches").val();
	var widthInches_dslab = ((widthInches-2)/2).toFixed(2);
		var d_slab = Math.round(widthInches_dslab);
  //alert(d_slab)
		$('#Width-inches-slab option:selected').removeAttr('selected');
		$("select#Width-inches-slab option[value='"+d_slab+"']").attr('selected', true);

}

/*
* Converts Slab Width to Rough Opening Width
*/
function slabHeightMeasurement() {
  var slabDimensions = parseInt($heightInSlab.val()) + parseFloat($heightQtSlab.val());
  var roDimensions = (slabDimensions + 2);
      
  $heightInRo.val(Math.floor(roDimensions)).trigger('change');
  $heightQtRo.val(roDimensions % 1).trigger('change');
}


/*
* Converts Slab Width to Rough Opening Width
*/
function slabHeightMeasurementPocketDoor() {
	
  
	
	
  var slabDimensions = parseInt($heightInSlab.val()) + parseFloat($heightQtSlab.val());
  var roDimensions1 = parseInt($heightInRo1.val()) + parseFloat($heightQtRo1.val());
  var roDimensions = ((slabDimensions + roDimensions1)+2.5);
      
  $heightInRo.val(Math.floor(roDimensions)).trigger('change');
  $heightQtRo.val(roDimensions % 1).trigger('change');
}
/*
* Converts Slab Width to Rough Opening Width
*/
function slabHeightMeasurementPocketDoor1() {
  var slabDimensions = parseInt($heightInSlab1.val()) + parseFloat($heightQtSlab1.val());
  var roDimensions1 = parseInt($heightInRo1.val()) + parseFloat($heightQtRo1.val());
  var roDimensions = ((slabDimensions + roDimensions1)+2.5);;
      
  $heightInRo1.val(Math.floor(roDimensions)).trigger('change');
  $heightQtRo1.val(roDimensions % 1).trigger('change');
}

/*
* Converts Slab Width to Rough Opening Width
*/
function slabHeightMeasurementDoublePocketDoor() {
	
  
	
	
  var slabDimensions = parseInt($heightInSlab.val()) + parseFloat($heightQtSlab.val());
  var roDimensions1 = parseInt($heightInRo1.val()) + parseFloat($heightQtRo1.val());
  var roDimensions = ((slabDimensions + roDimensions1)+2.5);
      
  $heightInRo.val(Math.floor(roDimensions)).trigger('change');
  $heightQtRo.val(roDimensions % 1).trigger('change');
}
/*
* Converts Slab Width to Rough Opening Width
*/
function slabHeightMeasurementDoublePocketDoor1() {
  var slabDimensions = parseInt($heightInSlab1.val()) + parseFloat($heightQtSlab1.val());
  var roDimensions1 = parseInt($heightInRo1.val()) + parseFloat($heightQtRo1.val());
  var roDimensions = ((slabDimensions + roDimensions1)+2.5);;
      
  $heightInRo1.val(Math.floor(roDimensions)).trigger('change');
  $heightQtRo1.val(roDimensions % 1).trigger('change');
}

/*
* Converts Slab Width to Rough Opening Width
*/
function slabHeightMeasurementPivot() {
	
  var slabDimensions = parseInt($heightInSlab.val()) + parseFloat($heightQtSlab.val());
  var roDimensions = (slabDimensions + 2);
      
  $heightInRo.val(Math.floor(roDimensions)).trigger('change');
  $heightQtRo.val(roDimensions % 1).trigger('change');
}

/*
* Converts Slab Width to Rough Opening Hight Bi-Fold
*/
function slabHeightMeasurementdouble() {
  var slabDimensions = parseInt($heightInSlab.val()) + parseFloat($heightQtSlab.val());
  var roDimensions = (slabDimensions + 2);
     
  $heightInRo.val(Math.floor(roDimensions)).trigger('change');
  $heightQtRo.val(roDimensions % 1).trigger('change');
}

/*
* Converts Slab Width to Rough Opening Hight Bi-Fold
*/
function slabHeightMeasurementbifold() {
  var slabDimensions = parseInt($heightInSlab.val()) + parseFloat($heightQtSlab.val());
  var roDimensions = (slabDimensions + 2);
     
  $heightInRo.val(Math.floor(roDimensions)).trigger('change');
  $heightQtRo.val(roDimensions % 1).trigger('change');
}


/*
* Converts Slab Width to Rough Opening Hight 3-Bi-Fold
*/
function slabHeightMeasurement3bifold() {
  var slabDimensions = parseInt($heightInSlab.val()) + parseFloat($heightQtSlab.val());
  var roDimensions = (slabDimensions + 2);
     
  $heightInRo.val(Math.floor(roDimensions)).trigger('change');
  $heightQtRo.val(roDimensions % 1).trigger('change');
}


/*
* Converts Slab Width to Rough Opening Hight 4-Bi-Fold
*/
function slabHeightMeasurement4bifold() {
  var slabDimensions = parseInt($heightInSlab.val()) + parseFloat($heightQtSlab.val());
  var roDimensions = (slabDimensions + 2);
     
  $heightInRo.val(Math.floor(roDimensions)).trigger('change');
  $heightQtRo.val(roDimensions % 1).trigger('change');
}

/*
* Converts Slab Width to Rough Opening Hight Barn Door
*/
function slabHeightMeasurementBarn() {
  var slabDimensions = parseInt($heightInSlab.val()) + parseFloat($heightQtSlab.val());
  var roDimensions = (slabDimensions - 3);
     
  $heightInRo.val(Math.floor(roDimensions)).trigger('change');
  $heightQtRo.val(roDimensions % 1).trigger('change');
}




/*
* Converts Slab Width to Rough Opening Hight Barn Double Door
*/
function slabHeightMeasurementBarnDouble() {
  var slabDimensions = parseInt($heightInSlab.val()) + parseFloat($heightQtSlab.val());
  var roDimensions = (slabDimensions - 3);
     
  $heightInRo.val(Math.floor(roDimensions)).trigger('change');
  $heightQtRo.val(roDimensions % 1).trigger('change');
}


/*
* Converts Rough Opening Width to Slab Width
*/
function roHeightMeasurementDoublePocketDoor() {
  var roDimensions = parseInt($heightInRo.val()) + parseFloat($heightQtRo.val());
  var roDimensions1 = parseInt($heightInRo1.val()) + parseFloat($heightQtRo1.val());
  console.log("roDimensions1"+roDimensions1);
 var slabDimensions = (roDimensions - 2.5);
  slabDimensions = (slabDimensions - roDimensions1);
  
  $heightInSlab.val(Math.floor(slabDimensions));
  $heightQtSlab.val(slabDimensions % 1);
}


/*
* Converts Rough Opening Width to Slab Width
*/
function roHeightMeasurementDoublePocketDoor1() {
	var roDimensions = parseInt($heightInRo.val()) + parseFloat($heightQtRo.val());
  var roDimensions1 = parseInt($heightInRo1.val()) + parseFloat($heightQtRo1.val());
 
  var slabDimensions = (roDimensions - 2.5);
  slabDimensions = (slabDimensions - roDimensions1);
   console.log("slabDimensions"+slabDimensions);
  $heightInSlab.val(Math.floor(slabDimensions));
  $heightQtSlab.val(slabDimensions % 1);
}

/*
* Converts Rough Opening Width to Slab Width
*/
function roHeightMeasurementPocketDoor() {
  var roDimensions = parseInt($heightInRo.val()) + parseFloat($heightQtRo.val());
  var roDimensions1 = parseInt($heightInRo1.val()) + parseFloat($heightQtRo1.val());
  console.log("roDimensions1"+roDimensions1);
 var slabDimensions = (roDimensions - 2.5);
  slabDimensions = (slabDimensions - roDimensions1);
  
  $heightInSlab.val(Math.floor(slabDimensions));
  $heightQtSlab.val(slabDimensions % 1);
}


/*
* Converts Rough Opening Width to Slab Width
*/
function roHeightMeasurementPocketDoor1() {
	var roDimensions = parseInt($heightInRo.val()) + parseFloat($heightQtRo.val());
  var roDimensions1 = parseInt($heightInRo1.val()) + parseFloat($heightQtRo1.val());
 
  var slabDimensions = (roDimensions - 2.5);
  slabDimensions = (slabDimensions - roDimensions1);
   console.log("slabDimensions"+slabDimensions);
  $heightInSlab.val(Math.floor(slabDimensions));
  $heightQtSlab.val(slabDimensions % 1);
}

/*
* Converts Rough Opening Width to Slab Width
*/
function roHeightMeasurement() {
  var roDimensions = parseInt($heightInRo.val()) + parseFloat($heightQtRo.val());
  var slabDimensions = (roDimensions - 2);
  
  $heightInSlab.val(Math.floor(slabDimensions));
  $heightQtSlab.val(slabDimensions % 1);
}

/*
* Converts Rough Opening Width to Slab Width
*/
function roHeightMeasurementPivot() {
  var roDimensions = parseInt($heightInRo.val()) + parseFloat($heightQtRo.val());
  var slabDimensions = (roDimensions - 2);
  console.log("here:"+slabDimensions);
  $heightInSlab.val(Math.floor(slabDimensions));
  $heightQtSlab.val(slabDimensions % 1);
}

/*
* Converts Rough Opening Width to Slab Width Bi-Fold
*/
function roHeightMeasurementbifold() {
  var roDimensions = parseInt($heightInRo.val()) + parseFloat($heightQtRo.val());
  var slabDimensions = (roDimensions - 1);
  
  $heightInSlab.val(Math.floor(slabDimensions));
  $heightQtSlab.val(slabDimensions % 1);
}

/*
* Converts Rough Opening Width to Slab Width 3-Bi-Fold
*/
function roHeightMeasurement3bifold() {
  var roDimensions = parseInt($heightInRo.val()) + parseFloat($heightQtRo.val());
  var slabDimensions = (roDimensions - 1);
  
  $heightInSlab.val(Math.floor(slabDimensions));
  $heightQtSlab.val(slabDimensions % 1);
}


/*
* Converts Rough Opening Width to Slab Width 4-Bi-Fold
*/
function roHeightMeasurement4bifold() {
  var roDimensions = parseInt($heightInRo.val()) + parseFloat($heightQtRo.val());
  var slabDimensions = (roDimensions - 1);
  
  $heightInSlab.val(Math.floor(slabDimensions));
  $heightQtSlab.val(slabDimensions % 1);
}
/*
* Converts Rough Opening Width to Slab Width Barn
*/
function roHeightMeasurementBarn() {
  var roDimensions = parseInt($heightInRo.val()) + parseFloat($heightQtRo.val());
  var slabDimensions = (roDimensions + 3);
  
  $heightInSlab.val(Math.floor(slabDimensions));
  $heightQtSlab.val(slabDimensions % 1);
}


/*
* Converts Rough Opening Width to Slab Width BarnDouble
*/
function roHeightMeasurementBarnDouble() {
  var roDimensions = parseInt($heightInRo.val()) + parseFloat($heightQtRo.val());
  var slabDimensions = (roDimensions + 3);
  
  $heightInSlab.val(Math.floor(slabDimensions));
  $heightQtSlab.val(slabDimensions % 1);
}


 
function disableQuarterCheck() {
  var $configMeasurement = $('.configMeasurement');
      
  $configMeasurement.each(function() {
    var $select = $(this).find('select').first();
    var lastOptionSelected = $select.find('option:last').is(':selected');
    var $quarterSelect = $select.next('select');
 
    if (lastOptionSelected) {
      $quarterSelect.prop('disabled', true);
      $quarterSelect.val(0);
      return; 
    }

    $quarterSelect.prop('disabled', false);
  });
}

function getRoWidth(roDimensions){
	var vv = (roDimensions % 1).toFixed(2);
	
	if(vv <= '0.20'  && vv >= '0.00'){
		console.log('1');
	  vv = '0';
	}else if(vv <= '0.35'  && vv > '0.20'){
		console.log('2');
	  vv = '0.25';
	}else if(vv <= '0.60'  && vv > '0.35'){
		console.log('3');
	  vv = '0.5';
	}else if(vv <= '0.90'  && vv > '0.60'){
		console.log('4');
	  vv = '0.75';
	} 
	
	return vv;
}

function getClearOpending(w){
	var v = .75;
	var v1 = ((w-1)-v);
	var v1= parseFloat(v1).toFixed(2);
	return v1;
}

function getWidth(widthInches_dslab){
		var vv = (widthInches_dslab % 1).toFixed(2);
		if(vv <= '0.10'  && vv >= '0.00'){
		  console.log('1');
		  vv = '0';
		}else if(vv <= '0.25'  && vv > '0.15'){
		  console.log('2');
		  vv = '.125';
		}else if(vv <= '0.40'  && vv > '0.25'){
		  console.log('3');
		  vv = '.375';
		}else if(vv <= '0.5'  && vv > '0.40'){
		  console.log('5');
		  vv = '.5';
		}else if(vv <= '0.70'  && vv > '0.50'){
		  console.log('6');
		  vv = '.625';
		}else if(vv <= '0.75'  && vv >'0.70'){
		  console.log('7');
		  vv = '.75';
		}else if(vv > '0.75'  ){
		  console.log('8');
		  vv = '.875';
		}

	
		
		return parseFloat(vv);
	
	
}

function generatePrice() {
	
  var price			 = 0;
   var per = 5;
  var $price = $("[data-total-price]");
  var $pricepercentage = $("[data-total-price1]");
  var $areaSqFt 	 = $('#areaSqFt');
  var quantity		 = parseInt($('select[name="properties[Quantity]"]').val());
  
  var widthInches  	 = parseFloat($('#Width-inches').val());
  var widthSlab  	 = parseFloat($('#Width-inches-slab').val());
  
  
  var width4ths=0; 
  
  
  if($('#Width-quarters').val() == '0'){
     var width4ths	   	 = parseFloat($('#Width-quarters').val());
  }else{
    if($('#Width-quarters').val() != null){
      var width4ths	   	 = parseFloat($('#Width-quarters').val().replace('0.', ''));
    }
  }
  
	var width4ths1 =0;
  if($('#Width-quarters-slab').val() == '0'){
    var type ='0';
     var width4ths1	   	 = parseFloat($('#Width-quarters-slab').val());
  }else{
    var type ='1';
    if($('#Width-quarters-slab').val() != null){
       var width4ths1	   	 = parseFloat($('#Width-quarters-slab').val().replace('0.', ''));
    }
     
  }

  var heightInches 	 = parseFloat($('#Height-inches').val());
  var heightSlab 	 = parseFloat($('#Height-inches-slab').val());
 
  var height4ths   	 = 0;

  if($('#Height-quarters').val() == '0'){
     var height4ths	   	 = parseFloat($('#Height-quarters').val());
  }else{
    if($('#Height-quarters').val() != null){
      var height4ths	   	 = parseFloat($('#Height-quarters').val().replace('0.', ''));
    }
  }
  var height4ths1=0;
  if($('#Height-quarters-slab').val() == '0'){
    var type1 ='0';
     var height4ths1	   	 = parseFloat($('#Height-quarters-slab').val());
  }else{
    var type1 ='1';
    if($('#Height-quarters-slab').val() != null){
      var height4ths1	   	 = parseFloat($('#Height-quarters-slab').val().replace('0.', ''));
    }
  }
  var p_type ='';
  var $variantSelect = $('select[name="id"]');
  var variantId      = $variantSelect.find('option:first').val();
  var roomName		 = $('input[name="properties[Room Name]"]').val();
 
  var tableRows 	 = '';
  var $configSummary = $('.configSummary');
  var $finaliseTable = $('.configSummary__Table');
  var $doorType      = $('#doorType');
  var product_title = $('#pro_title').text();
  if($doorType.val() == 'pocket-door' || $doorType.val() == 'double-pocket-door'){
	 var $options		 = $('#wizard input.configOption__Radio:checked'); 
  }else{
	 var $options		 = $('#wizard input[type="radio"]:checked'); 
  }
  
  
  
  
  var height = heightInches + (height4ths/100);
  var width  = widthInches + (width4ths/100);
  
  $variantSelect.find('option').each(function() {
    var $option 	  = $(this);
    var optionVal	  = parseFloat($option.text());
      
    if (height > optionVal) {
      variantId = $(this).next('option').val();
    }
  });
 
 
  var heightSlab = heightSlab + (height4ths1/100);
  var widthSlab  = widthSlab + (width4ths1/100);
console.log("Type:"+$doorType.val());
 if ($doorType.val() === 'double door') {
  var areaInFt = Math.ceil((((width - 3) * (height - 2)) * 2) / 144);
  //var areaInFt = getSlabSQFT(widthSlab,heightSlab,2);
 } else if ($doorType.val() === 'barn-double-door') {
	
  var areaInFt = Math.ceil(((width - 2) * (height - 1)) / 144);
  //var areaInFt = getSlabSQFT(widthSlab,heightSlab,2);
 }else if ($doorType.val() === 'barn-door') {
	
  var areaInFt = Math.ceil(((width - 2) * (height - 1)) / 144);
  //var areaInFt = getSlabSQFT(widthSlab,heightSlab,2);
 } else if ($doorType.val() === 'Bi-Fold') {
	
  var areaInFt = Math.ceil(((width - 2) * (height - 1)) / 144);
  //var areaInFt = getSlabSQFT(widthSlab,heightSlab,2);
 } else if ($doorType.val() === '3-Bi-Fold') {
  var areaInFt = Math.ceil(((width - 2) * (height - 1)) / 144);
  //var areaInFt = getSlabSQFT(widthSlab,heightSlab,3);
 }else if ($doorType.val() === '4-Bi-Fold') {
  var areaInFt = Math.ceil(((width - 2) * (height - 1)) / 144);
  //var areaInFt = getSlabSQFT(widthSlab,heightSlab,4);
 }else if ($doorType.val() === 'pivot door') {
  //var areaInFt = Math.ceil(((width - 3) * (height - 2)) / 144);
   var areaInFt = 0;
 }else if ($doorType.val() === 'pocket-door') {
	 p_type = $('#pocket_color').val()
var areaInFt = Math.ceil(((width - 2) * (height - 1)) / 144);
   //var areaInFt = 0;
 }else if ($doorType.val() === 'double-pocket-door') {
	 p_type = $('#pocket_color').val()
var areaInFt = Math.ceil(((width - 2) * (height - 1)) / 144);
   //var areaInFt = 0;
 } else {
  var areaInFt = Math.ceil(((width - 3) * (height - 2)) / 144);
 }
  var areaInFt = 0;
 
 // var for_input_areaInFt = areaInFt * quantity // TODO delete?
  $areaSqFt.val(areaInFt);
  
  // $areaSqFt.val(areaInFt)
  
  var priceSqFt = areaInFt * $areaSqFt.data('price');
  price += priceSqFt;
  
  
  console.log("areaSqFt"+areaSqFt);
  console.log("priceSqFt"+priceSqFt);
      
  $variantSelect.val(variantId).trigger('change');
  
  price += $variantSelect.find('option:selected').data('price');
  
  //alert(price);
   
  $finaliseTable.find('tbody').empty();
  
  if (roomName != '') tableRows += '<tr><td class="configSummary__TableItem">Room Name</td><td class="configSummary__TableItem">'+roomName+'</td>';
   if ($doorType.val() === 'pocket-door') {
     var p_name = $("#p_name").val();
    tableRows += '<tr class="pr_title" data-config-variant="'+variantId+'"><td class="configSummary__TableItem test">'+p_name+'. Track and Wheels Included.';
    tableRows += '<p><small>Rough Opening: '+widthInches+'.'+width4ths+'\" x '+heightInches+'.'+height4ths+'"</small></p>';
   }else if ($doorType.val() === 'double-pocket-door') {
     var p_name = $("#p_name").val();
    tableRows += '<tr class="pr_title" data-config-variant="'+variantId+'"><td class="configSummary__TableItem test">'+p_name+'. Track and Wheels Included.';
    tableRows += '<p><small>Rough Opening: '+widthInches+'.'+width4ths+'\" x '+heightInches+'.'+height4ths+'"</small></p>';
   }else if($doorType.val() === 'barn-door'){
	tableRows += '<tr class="pr_title" data-config-variant="'+variantId+'"><td class="configSummary__TableItem test">'+product_title+' Door Frame including Hinges';
    tableRows += '<p><small>Finished Opening: '+widthInches+'.'+width4ths+'\" x '+heightInches+'.'+height4ths+'"</small></p>';   
   }else{
	tableRows += '<tr class="pr_title" data-config-variant="'+variantId+'"><td class="configSummary__TableItem test">'+product_title+' Door Frame including Hinges';
    tableRows += '<p><small>Rough Opening: '+widthInches+'.'+width4ths+'\" x '+heightInches+'.'+height4ths+'"</small></p>';   
   }
   
  var widthInches_dslab = ((widthInches-2)/2).toFixed(2);
  var d_slab = Math.round(widthInches_dslab);
  console.log("TT:"+$doorType.val());
  var v ='';
   if ($doorType.val() === 'barn-door') {
	 var ww = widthInches+"."+width4ths;
	console.log("wwdd"+ww);
	var widthInches_dslab = ((parseFloat(ww)+8));
	console.log(type+"wwdd"+widthInches_dslab);
    if(type == '1'){
		var vv =  getWidth(widthInches_dslab);
		var w = Math.floor(widthInches_dslab);
		var w = w+vv;
		console.log("w "+w);
	}else{
		 var w = widthInches_dslab+'.'+width4ths1;
	}
	
	var h = (heightInches+3)+'.'+height4ths1;
	 
    tableRows += '<p><small>Door Slab: '+w+'\" x '+h+'"</small></p>';
	var v = getSlabSQFT(w,h,1);
    tableRows += '<p><small>Slab Size Area: '+v+' SQ FT</small></p>';
  }else if ($doorType.val() === 'barn-double-door') {
	 var ww = widthInches+"."+width4ths;
	console.log("wwdd"+ww);
	var widthInches_dslab = ((parseFloat(ww)+14)/2);
	console.log(type+"wwdd"+widthInches_dslab);
    if(type == '1'){
		var vv =  getWidth(widthInches_dslab);
		var w = Math.floor(widthInches_dslab);
		var w = w+vv;
		console.log("w "+w);
	}else{
		 var w = widthInches_dslab+'.'+width4ths1;
	}
	
	var h = (heightInches+3)+'.'+height4ths1;
	 
    tableRows += '<p><small>Door Slab A,B: '+w+'\" x '+h+'"</small></p>';
	var v = getSlabSQFT(w,h,2);
    tableRows += '<p><small>Slab Size Area: '+v+' SQ FT</small></p>';
  }
 else if ($doorType.val() === 'double door') {
	 var ww = widthInches+"."+width4ths;
	console.log("ww"+ww);
	var widthInches_dslab = ((ww-2)/2);
    if(type == '1'){
		var vv =  getWidth(widthInches_dslab);
		var w = Math.floor(widthInches_dslab);
		var w = w+vv;
		console.log("w "+w);
	}else{
		 var w = widthInches_dslab+'.'+width4ths1;
	}
	
	var h = (heightInches-1)+'.'+height4ths1;
	 
    tableRows += '<p><small>Door Slab A: '+w+'\" x '+h+'"</small></p>';
    tableRows += '<p><small>Door Slab B: '+w+'\" x '+h+'"</small></p>';
	var v = getSlabSQFT(w,h,2);
    tableRows += '<p><small>Slab Size Area: '+v+' SQ FT</small></p>';
  }
 else if($doorType.val() === 'Bi-Fold'){
    
	var ww = widthInches+"."+width4ths;
	
	var widthInches_dslab = ((ww-2)/2);
	 if(type == '1'){
		var vv =  getWidth(widthInches_dslab);
		var w = Math.floor(widthInches_dslab);
		var w = w+vv;
		console.log("w "+w);
	}else{
		 var w = widthInches_dslab+'.'+width4ths1;
	}
	
	var h = (heightInches-1)+'.'+height4ths1;
	
   console.log("width new "+w);
    tableRows += '<p><small>Door Slab A,B: '+w+'\" x '+h+'"</small></p>';
	var v = getSlabSQFT(w,h,2);
    tableRows += '<p><small>Slab Size Area: '+v+' SQ FT</small></p>';
    //tableRows += '<p><small>Door Slab B: '+w+'\" x '+h+'"</small></p>';
  
 }
 else if($doorType.val() === '3-Bi-Fold'){
	console.log(parseFloat($('#Width-quarters').val()));
	var ww = widthInches+"."+width4ths;
	var widthInches_dslab = ((ww-2)/3);
    if(type == '1'){
		var vv =  getWidth(widthInches_dslab);
		var w = Math.floor(widthInches_dslab);
		var w = w+vv;
		console.log("w "+w);
	}else{
		 
		 var w = widthInches_dslab+'.'+width4ths1;
	}
	
	var h = (heightInches-1)+'.'+height4ths1;
    tableRows += '<p><small>Door Slab A,B,C: '+w+'\" x '+h+'"</small></p>';
    //tableRows += '<p><small>Door Slab B: '+w+'\" x '+h+'"</small></p>';
	var v = getSlabSQFT(w,h,3);
    tableRows += '<p><small>Slab Size Area: '+v+' SQ FT</small></p>';
  
 }
 else if($doorType.val() === '4-Bi-Fold'){
   var ww = widthInches+"."+width4ths;
	var widthInches_dslab = ((ww-2)/4);
   if(type == '1'){
		var vv =  getWidth(widthInches_dslab);
		var w = Math.floor(widthInches_dslab);
		var w = w+vv;
		console.log("w "+w);
	}else{
		 
		 var w = widthInches_dslab+'.'+width4ths1;
	}
	
	var h = (heightInches-1)+'.'+height4ths1;
	
    tableRows += '<p><small>Door Slab A,B,C,D: '+w+'\" x '+h+'"</small></p>';
	var v = getSlabSQFT(w,h,1);
    tableRows += '<p><small>Slab Size Area: '+v+' SQ FT</small></p>';
    //tableRows += '<p><small>Door Slab B: '+w+'\" x '+h+'"</small></p>';
  
 }else if($doorType.val() === 'pocket-door'){
	 
	 var ww = widthInches+"."+width4ths;
	var widthInches_dslab = (((ww-5)/2)+1.75);
	var widthInches_dslab1 = (((ww-5)/2));
   if(type == '1'){
		var vv =  getWidth(widthInches_dslab);
		var w = Math.floor(widthInches_dslab);
		var w = w+vv;
		console.log("wddd "+widthInches_dslab);
		
		var vv1 =  getWidth(widthInches_dslab1);
		var w1 = Math.floor(widthInches_dslab1);
		var w1 = w1+vv1;
		
	}else{
		 
		 var w = widthInches_dslab+'.'+width4ths1;
		 var w1 = widthInches_dslab1+'.'+width4ths1;
	}
	
	 var heightInches1 	 = parseFloat($('#Height-inches1').val());
	  var heightSlab1 	 = parseFloat($('#Height-inches-slab1').val());
	
	var h = ((heightInches-heightInches1)-2.5);
	
    tableRows += '<p><small>Door Slab: '+w+'\" x '+h+' x '+1.5+'\"</small></p>';
		var c = getClearOpending(w);
		tableRows += '<p><small>Clear Opening: '+(w1)+'"</small></p>';
		
	 var v = getSlabSQFT(w,h,2);
	 

	  var heightInches 	 = parseFloat($('#Height-inches1').val());
	  var heightSlab 	 = parseFloat($('#Height-inches-slab1').val());
	 
	  var height4ths   	 = 0;

	  if($('#Height-quarters1').val() == '0'){
		 var height4ths	   	 = parseFloat($('#Height-quarters1').val());
	  }else{
		if($('#Height-quarters1').val() != null){
		  var height4ths	   	 = parseFloat($('#Height-quarters1').val().replace('0.', ''));
		}
	  }
	  var height4ths1=0;
	  if($('#Height-quarters-slab1').val() == '0'){
		var type1 ='0';
		 var height4ths1	   	 = parseFloat($('#Height-quarters-slab1').val());
	  }else{
		var type1 ='1';
		if($('#Height-quarters-slab1').val() != null){
		  var height4ths1	   	 = parseFloat($('#Height-quarters-slab1').val().replace('0.', ''));
		}
	  }
	 
	 
	 
   var ww = widthInches+"."+width4ths;
	var widthInches_dslab = ((ww*2)+2);
   if(type == '1'){
		var vv =  getWidth(widthInches_dslab);
		var w = Math.floor(widthInches_dslab);
		var w = w+vv;
		console.log("w "+w);
	}else{
		 
		 var w = widthInches_dslab+'.'+width4ths1;
	}
	
	var h = heightInches+'.'+height4ths1;
	
    tableRows += '<p><small>Finished Floor Allowance: '+h+'"</small></p>';
	
    tableRows += '<p><small>Slab Size Area: '+v+' SQ FT</small></p>';
	var slab_type = $('[name="slab_type"]:checked').val();
   // tableRows += '<p><small>Slab Type: '+slab_type+'</small></p>';
    //tableRows += '<p><small>Door Slab B: '+w+'\" x '+h+'"</small></p>';
  
 }
 else if($doorType.val() === 'double-pocket-door'){
	 
	 var ww = widthInches+"."+width4ths;
	var widthInches_dslab = (((ww-10)/4)+1.75);
	var widthInches_dslab1 = (((ww-10)/2));
   if(type == '1'){
		var vv =  getWidth(widthInches_dslab);
		
		var w = Math.floor(widthInches_dslab);
		var w = w+vv;
		console.log("wddd "+widthInches_dslab);
		
		var vv1 =  getWidth(widthInches_dslab1);
		var w1 = Math.floor(widthInches_dslab1);
		var w1 = w1+vv1;
		
	}else{
		 var w = widthInches_dslab+'.'+width4ths1;
		 var w1 = widthInches_dslab1+'.'+width4ths1;
	}
	
	
	 var heightInches1 	 = parseFloat($('#Height-inches1').val());
	  var heightSlab1 	 = parseFloat($('#Height-inches-slab1').val());
	
	var h = ((heightInches-heightInches1)-2.5);
	
	
    tableRows += '<p><small>Door Slab A,B: '+w+'\" x '+h+' x '+1.5+'\"</small></p>';
		var c = getClearOpending(w);
		tableRows += '<p><small>Clear Opening: '+(w1)+'"</small></p>';
		
	 var v = getSlabSQFT(w,h,2);
	 

	  var heightInches 	 = parseFloat($('#Height-inches1').val());
	  var heightSlab 	 = parseFloat($('#Height-inches-slab1').val());
	 
	  var height4ths   	 = 0;

	  if($('#Height-quarters1').val() == '0'){
		 var height4ths	   	 = parseFloat($('#Height-quarters1').val());
	  }else{
		if($('#Height-quarters1').val() != null){
		  var height4ths	   	 = parseFloat($('#Height-quarters1').val().replace('0.', ''));
		}
	  }
	  var height4ths1=0;
	  if($('#Height-quarters-slab1').val() == '0'){
		var type1 ='0';
		 var height4ths1	   	 = parseFloat($('#Height-quarters-slab1').val());
	  }else{
		var type1 ='1';
		if($('#Height-quarters-slab1').val() != null){
		  var height4ths1	   	 = parseFloat($('#Height-quarters-slab1').val().replace('0.', ''));
		}
	  }
	 
	 
	 
   var ww = widthInches+"."+width4ths;
	var widthInches_dslab = ((ww*2)+2);
   if(type == '1'){
		var vv =  getWidth(widthInches_dslab);
		var w = Math.floor(widthInches_dslab);
		var w = w+vv;
		console.log("w "+w);
	}else{
		 
		 var w = widthInches_dslab+'.'+width4ths1;
	}
	
	var h = heightInches+'.'+height4ths1;
	
    tableRows += '<p><small>Finished Floor Allowance: '+h+'"</small></p>';
	
    //tableRows += '<p><small>Slab Size Area: '+v+' SQ FT</small></p>';
	var slab_type = $('#slab_type').val();
    tableRows += '<p><small>Description: '+slab_type+'</small></p>';
    //tableRows += '<p><small>Door Slab B: '+w+'\" x '+h+'"</small></p>';
  
 }else if ($doorType.val() === 'pivot door') {
	 tableRows += '<p><small>Door Slab: '+(widthInches-3)+'.'+width4ths+'\" x '+(heightInches-2)+'.'+height4ths+'"</small></p>';
  }else if ($doorType.val() === 'single door') {
	   tableRows += '<p><small>Door Slab: '+(widthInches-3)+'.'+width4ths+'\" x '+(heightInches-2)+'.'+height4ths+'"</small></p>';
	  var w = widthInches+"."+width4ths;
	  var h = heightInches+"."+height4ths;
	  var v = getSlabSQFT(w,h,1);
	
	  tableRows += '<p><small>Slab Size Area: '+v+' SQ FT</small></p>';
  }else {
	 
  	tableRows += '<p><small>Door Slab: '+(widthInches-3)+'.'+width4ths+'\" x '+(heightInches-2)+'.'+height4ths+'"</small></p>';
  }  
  
  tableRows += '</td>'
  tableRows += '<td class="configSummary__TableItem">'+theme.Currency.formatMoney(price, theme.moneyFormat)+'</td></tr>';
  
  tableRows += '<input type="hidden" name="sqft" id="sqft" value="'+v+'"/>';
   
  //tableRows += '<tr><td class="configSummary__TableItem">Door area SQ FT</td>'
  //tableRows += '<td class="configSummary__TableItem">'+theme.Currency.formatMoney(priceSqFt, theme.moneyFormat)+'</td></tr>';
  
  var tt='';
  console.log("p_type: "+p_type);
  
  if(p_type !=''){
	  
	  $options.each(function(index) {
		  console.log('index'+index+" "+$doorType.val());
		  var $p_id =$('#p_id').val();
		  if ($doorType.val() === 'single door') {
			 if(index==1){
				  var tt = 'Hinge Frame';
			  }else if(index==2){
				  var tt = 'Closure';
			  }else{
				  var tt='Finish Frame';
			  }
		  }else{
				
				if( $p_id == '8388498325810' ||  $p_id == '8398933918002' ){
				  if(index==1){
					  var tt = 'Slab Finish';
				  }else if(index==2){
					var tt = 'Closure';
					 var p_type = $("#pocket_color").val() ; 
					  
				  }else{
					  var tt='Finish Frame';
				  }
				}else{
				  if(index==2){
					  var tt = 'Finish Frame';
				  }else{
					  var tt='Closure';
				  } 
				}
		  }
		 
		 var vvv = $(this).val();
		var vvv1 =  vvv.replace(/<br\s*\/?>/gi, ' ');
		 if( $p_id == '8388498325810' ||  $p_id == '8398933918002' ){
		
			 if(index ==2 ){
				tableRows += '<tr><td class="configSummary__TableItem">'+tt+': '+vvv1+"-"+p_type+'</td><td class="configSummary__TableItem uu">+'+theme.Currency.formatMoney($(this).data('price'), theme.moneyFormat)+'</td></tr>';
				
				var closure_size = $("#closure_size").val();
				var closure_size_price = parseInt($("#closure_size_price").val());
				if(closure_size !=''){

					tt = 'Pocket Size';
					tableRows +=
					'<tr><td class="configSummary__TableItem size">' +
					tt +
					": " +
					closure_size +
					'</td><td class="configSummary__TableItem size_val">+' +
					theme.Currency.formatMoney(
					closure_size_price,
					theme.moneyFormat
					) +
					"</td></tr>";
					price += closure_size_price;	
				}
				
				price += $(this).data('price');
			 }else if(index ==1 ){
				 
				var slabfinish = $('input[name="Slab Finish"]:checked');

				var slabfinishVal = slabfinish.val(); 

				var slabfinishPrice = slabfinish.data("price");
				var slabfinishVal2 = slabfinishVal.replace(/<br\s*\/?>/gi, ' ');
				// Get the index of the selected option
				var selectedIndex = $('input[name="Slab Finish"]').index(slabfinish);
				console.log("slabfinishVal2: "+slabfinishVal2);
				console.log("slabfinishPrice: "+slabfinishPrice);
				tableRows += '<tr><td class="configSummary__TableItem">'+tt+': '+vvv1+'</td><td class="configSummary__TableItem uu">+'+theme.Currency.formatMoney($(this).data('price'), theme.moneyFormat)+'</td></tr>';
				
				if (selectedIndex === 0) {

					} else if (selectedIndex === 1) {
						var premium_clr = $("div.slab_div.configItem input[name='premium_clr']").val();
						if (premium_clr !== '') {
							tableRows += '<tr><td class="configSummary__TableItem"><p><small>Laminate : ' + premium_clr + '</small></p></td></tr>';
						}slabfinishVal2
					} else if (selectedIndex === 2) {
							var color_pickeerr = $('input#color_pickeerr').val();
						if (color_pickeerr !== '') {
							tableRows += '<tr><td class="configSummary__TableItem"><p><small>Color: ' + color_pickeerr + '</small></p></td></tr>';
						} 
					} else if (selectedIndex === 3) {
						var box_name = $('div.slab_div.configItem  input[name="box_name"]').val();
						if (box_name !== '') {
							tableRows += '<tr><td class="configSummary__TableItem"><p><small>Veneers : ' + box_name + '</small></p></td></tr>';
						}
					}
				price += $(this).data('price');
				
			 }else{
				tableRows += '<tr><td class="configSummary__TableItem">'+tt+': '+vvv1+'</td><td class="configSummary__TableItem yy">+'+theme.Currency.formatMoney($(this).data('price'), theme.moneyFormat)+'</td></tr>';
				price += $(this).data('price'); 
			 }
		 }else{
			tableRows += '<tr><td class="configSummary__TableItem">'+tt+': '+vvv1+'</td><td class="configSummary__TableItem yy">+'+theme.Currency.formatMoney($(this).data('price'), theme.moneyFormat)+'</td></tr>';
				price += $(this).data('price');  
		 }
		 
		 
		
	  });
  }else{
		$options.each(function(index) {
		  console.log('index'+index)
		  console.log('index'+index+" "+$doorType.val())
			var s ='';
		 if ($doorType.val() === 'single door') {
			 if(index==1){
				  var tt = 'Hinge Frame';
			  }else if(index==2){
				  var tt = 'Closure';
			  }else{
				  var tt='Finish Frame';
			  }
		  }else{
			  var $p_id =$('#p_id').val();
			   if( $p_id == '8388498325810' ||  $p_id == '8398933918002' ){
				  if(index==1){
					  var tt = 'Slab Finish';
				  }else if(index==2){
					  var tt = 'Closure';
					  var p_type = $("#pocket_color").val() ; 
					  
				  }else{
					  var tt='Finish Frame';
				  }
			   }else{
				  if(index==2){
					  var tt = 'Finish Frame';
				  }else{
					  var tt='Closure';
				  } 
			   }
		  }
		  
		  
         var vvv = $(this).val();
		var vvv1 =  vvv.replace(/<br\s*\/?>/gi, ' ');
		  
		  tableRows += '<tr><td class="configSummary__TableItem">'+tt+': '+vvv1+'</td><td class="configSummary__TableItem yy">+'+theme.Currency.formatMoney($(this).data('price'), theme.moneyFormat)+'</td></tr>';
		price += $(this).data('price'); 
		// price += priceSqFt; 
		  
		
		
	  });  
  }
  
  
  tableRows += '<tr><td class="configSummary__TableItem">Total Price Door Frame + Add-On\'s</td>'
  tableRows += '<td class="configSummary__TableItem">'+theme.Currency.formatMoney(price, theme.moneyFormat)+'</td></tr>';
  
  tableRows += '<tr><td class="configSummary__TableItem">Quantity</td>'
  tableRows += '<td class="configSummary__TableItem">'+quantity+'</td></tr>';
    
  price = price * quantity;


  tableRows +=
    '<tr><td class="configSummary__TableItem configSummary__TableItem--total">Total</td>';
  tableRows +=
    '<td class="configSummary__TableItem configSummary__TableItem--total">' +
    theme.Currency.formatMoney(price, theme.moneyFormat) +
    "</td></tr>";

  

  $price.text(theme.Currency.formatMoney(price, theme.moneyFormat));
  
  var price = (price+((price*per)/100));
  
  $pricepercentage.html('<s class="price-item price-item--regular">'+theme.Currency.formatMoney(price, theme.moneyFormat)+'</s>');
  tableRows +=
    '<tr><td class="configSummary__TableItem configSummary__TableItem--total"></td>';
  tableRows +=
    '<td class="configSummary__TableItem configSummary__TableItem--total"><span class="price-item price-item--regular" data-total-price1><s class="price-item price-item--regular">'+ theme.Currency.formatMoney(price, theme.moneyFormat)+"</s></span></td></tr>";
	$finaliseTable.prepend(tableRows);
  
  // var abc = $price.text(theme.Currency.formatMoney(
    // price,
    // theme.moneyFormat
    
  // ));

}

// suno song only for you
function getWidthCart(widthInches_dslab){
	var vv= getWidth(widthInches_dslab);
	var w = Math.floor(widthInches_dslab);
	var w = w+vv;
	return w;
}

function getSlabSQFT(w,h,t){
	var v = ((w*h)/144).toFixed(2);
	var v = Math.round(v*t);
	return v;
}


function addToCart() { 

  var areaSqFt       = $('#areaSqFt');
  var $doorType      = $('#doorType');
  
 
  var p_type ='';
  var timestamp  	 = $.now();
  var items 		 = [];
  var variantId      = $('[data-config-variant]').data('config-variant');
  var roomName		 = $('input[name="properties[Room Name]"]').val();
  var quantity		 = parseInt($('select[name="properties[Quantity]"]').val());
 
  var widthInches  	 = parseFloat($('#Width-inches').val());
   var width4ths=0;
  if($('#Width-quarters').val() == '0'){
     var width4ths	   	 = parseFloat($('#Width-quarters').val());
  }else{
    if($('#Width-quarters').val() != null){
      var width4ths	   	 = parseFloat($('#Width-quarters').val().replace('0.', ''));
    }
  }
	var width4ths1 =0;
  if($('#Width-quarters-slab').val() == '0'){
    var type ='0';
     var width4ths1	   	 = parseFloat($('#Width-quarters-slab').val());
  }else{
    var type ='1';
    if($('#Width-quarters-slab').val() != null){
       var width4ths1	   	 = parseFloat($('#Width-quarters-slab').val().replace('0.', ''));
    }
     
  }

  var heightInches 	 = parseFloat($('#Height-inches').val());
 
  var height4ths   	 = 0;

  if($('#Height-quarters').val() == '0'){
     var height4ths	   	 = parseFloat($('#Height-quarters').val());
  }else{
    if($('#Height-quarters').val() != null){
      var height4ths	   	 = parseFloat($('#Height-quarters').val().replace('0.', ''));
    }
  }
  var height4ths1=0;
  if($('#Height-quarters-slab').val() == '0'){
    var type1 ='0';
     var height4ths1	   	 = parseFloat($('#Height-quarters-slab').val());
  }else{
    var type1 ='1';
    if($('#Height-quarters-slab').val() != null){
      var height4ths1	   	 = parseFloat($('#Height-quarters-slab').val().replace('0.', ''));
    }
  }
  var closure		 = $('input[name="Closure"]:checked');
if ($doorType.val() === 'barn-double-door'  || $doorType.val() === 'barn-door' || $doorType.val() ) {
		
   }else{
	   var finish		 = $('input[name="Frame Finish"]:checked');
   }
   
 
if ($doorType.val() === 'barn-double-door' || $doorType.val() === 'barn-door') {
	var doorObj = {
		'Door ID': timestamp,
		'Room Name': roomName,
		'Finish Opening': widthInches+'.'+width4ths+'" x '+heightInches+'.'+height4ths+'"',
	  }
 }else if ($doorType.val() === 'pocket-door' || $doorType.val() === 'double-pocket-door') {
	   var slab_type = $('#slab_type').val();

	var doorObj = {
		'Door ID': timestamp,
		'Room Name': roomName,
		'Rough Opening': widthInches+'.'+width4ths+'" x '+heightInches+'.'+height4ths+'"',
		'Description':slab_type,
	  }
	 
 }  else{
	 var doorObj = {
		'Door ID': timestamp,
		'Room Name': roomName,
		'Rough Opening': widthInches+'.'+width4ths+'" x '+heightInches+'.'+height4ths+'"',
	  }
 }

  if ($doorType.val() === 'barn-door' ) {
	  var ww = widthInches+"."+width4ths;
	console.log("wwdd"+ww);
	var widthInches_dslab = ((parseFloat(ww)+8));
	  if(type == '1'){
		 var w = widthInches_dslab;
	}else{
		 
		 var w = widthInches_dslab+'.'+width4ths1;
	}
	
	var h = (heightInches+3)+'.'+height4ths1;
	 
   var slab = w+'" x '+h+'"';
    doorObj['Door Slab'] = slab;
	var v = getSlabSQFT(w,h,1);
	doorObj['Slab Size Area'] = v+" SQ FT";
 } else if ($doorType.val() === 'barn-double-door' ) {
	  var ww = widthInches+"."+width4ths;
	console.log("wwdd"+ww);
	var widthInches_dslab = ((parseFloat(ww)+14)/2);
	  if(type == '1'){
		 var w = widthInches_dslab;
	}else{
		 
		 var w = widthInches_dslab+'.'+width4ths1;
	}
	
	var h = (heightInches+3)+'.'+height4ths1;
	 
   var slab = w+'" x '+h+'"';
    doorObj['Door Slab A,B'] = slab;
	var v = getSlabSQFT(w,h,2);
	doorObj['Slab Size Area'] = v+" SQ FT";
 }else if ($doorType.val() === 'double door') {
	   var widthInches_dslab = ((widthInches-2)/2);
	  if(type == '1'){
		 var w = widthInches_dslab;
	}else{
		 
		 var w = widthInches_dslab+'.'+width4ths1;
	}
	
	var h = (heightInches-1)+'.'+height4ths1;
	 
   var slab = w+'" x '+h+'"';
    doorObj['Door Slab A'] = slab;
    doorObj['Door Slab B'] = slab;
	var v = getSlabSQFT(w,h,2);
	doorObj['Slab Size Area'] = v+" SQ FT";
 }else if ($doorType.val() === 'Bi-Fold') {
   var ww = widthInches+"."+width4ths;
	console.log("ww"+ww);
	var widthInches_dslab = ((ww-2)/2);
    if(type == '1'){
		 var w = getWidthCart(widthInches_dslab);
	}else{
		 
		 var w = widthInches_dslab+'.'+width4ths1;
	}
	
	var h = (heightInches-1)+'.'+height4ths1;
    var slab = w+'" x '+h+'"';
    doorObj['Door Slab A,B'] = slab;
	var v = getSlabSQFT(w,h,2);
	doorObj['Slab Size Area'] = v+" SQ FT";
   // doorObj['Door Slab B'] = slab;
 }else if ($doorType.val() === '3-Bi-Fold') {
   var ww = widthInches+"."+width4ths;
	console.log("ww"+ww);
	var widthInches_dslab = ((ww-2)/3);
   if(type == '1'){
		var w = getWidthCart(widthInches_dslab);
		 
	}else{
		 
		 var w = widthInches_dslab+'.'+width4ths1;
	}
	
	var h = (heightInches-1)+'.'+height4ths1;
    var slab = w+'" x '+h+'"';
    doorObj['Door Slab A,B,C'] = slab;
	var v = getSlabSQFT(w,h,3);
	doorObj['Slab Size Area'] = v+" SQ FT";
   // doorObj['Door Slab B'] = slab;
 }else if ($doorType.val() === '4-Bi-Fold') {
   var ww = widthInches+"."+width4ths;
	console.log("ww"+ww);
	var widthInches_dslab = ((ww-2)/4);
    if(type == '1'){
		 var w = getWidthCart(widthInches_dslab);
	}else{
		 
		 var w = widthInches_dslab+'.'+width4ths1;
	}
	
	var h = (heightInches-1)+'.'+height4ths1;
    var slab = w+'" x '+h+'"';
    doorObj['Door Slab A,B,C,D'] = slab;
	var v = getSlabSQFT(w,h,4);
	doorObj['Slab Size Area'] = v+" SQ FT";
   // doorObj['Door Slab B'] = slab;
 }else if ($doorType.val() === 'pocket-door') {
	 var p_type = $("#pocket_color").val();
   var ww = widthInches+"."+width4ths;
	console.log("ww"+ww);
	var widthInches_dslab = (((ww-5)/2)+1.75);
	var widthInches_dslab1 = (((ww-5)/2));
    if(type == '1'){
		 var w = getWidthCart(widthInches_dslab);
		 var w1 = getWidthCart(widthInches_dslab1);
	}else{
		 
		 var w = widthInches_dslab+'.'+width4ths1;
		 var w1 = widthInches_dslab1+'.'+width4ths1;
	}
	
	var heightInches1 	 = parseFloat($('#Height-inches1').val());
	  var heightSlab1 	 = parseFloat($('#Height-inches-slab1').val());
	
	var h = ((heightInches-heightInches1)-2.5);
    var slab = w+'" x '+h+'"';
    doorObj['Door Slab'] = slab+" x "+1.5+'"';
	
    var c = getClearOpending(w);
	
	doorObj['Clear Opening'] = w1+'"';
	var v = getSlabSQFT(w,h,2);
	
	
	
	 var widthInches  	 = parseFloat($('#Width-inches1').val());
	   var width4ths=0;
	  if($('#Width-quarters1').val() == '0'){
		 var width4ths	   	 = parseFloat($('#Width-quarters1').val());
	  }else{
		if($('#Width-quarters1').val() != null){
		  var width4ths	   	 = parseFloat($('#Width-quarters1').val().replace('0.', ''));
		}
	  }
		
	  var heightInches 	 = parseFloat($('#Height-inches1').val());
	 
	  var height4ths   	 = 0;

	  if($('#Height-quarters1').val() == '0'){
		 var height4ths	   	 = parseFloat($('#Height-quarters1').val());
	  }else{
		if($('#Height-quarters1').val() != null){
		  var height4ths	   	 = parseFloat($('#Height-quarters1').val().replace('0.', ''));
		}
	  }
	  var height4ths1=0;
	  if($('#Height-quarters-slab1').val() == '0'){
		var type1 ='0';
		 var height4ths1	   	 = parseFloat($('#Height-quarters-slab1').val());
	  }else{
		var type1 ='1';
		if($('#Height-quarters-slab1').val() != null){
		  var height4ths1	   	 = parseFloat($('#Height-quarters-slab1').val().replace('0.', ''));
		}
	  }
	
	var h = heightInches+'.'+height4ths1;
    var slab = h+'"';
	
	
    doorObj['Finished Floor Allowance'] = slab;
	doorObj['Slab Size Area'] = v+" SQ FT";
   // doorObj['Door Slab B'] = slab;
 }
 else if ($doorType.val() === 'double-pocket-door') {
	 var p_type = $("#pocket_color").val();
	 
   var ww = widthInches+"."+width4ths;
	console.log("ww"+ww);
	var widthInches_dslab = (((ww-10)/4)+1.75);
	var widthInches_dslab1 = (((ww-10)/2));
    if(type == '1'){
		 var w = getWidthCart(widthInches_dslab);
		 var w1 = getWidthCart(widthInches_dslab1);
	}else{
		 
		 var w = widthInches_dslab+'.'+width4ths1;
		 var w1 = widthInches_dslab1+'.'+width4ths1;
	}
	
	var heightInches1 	 = parseFloat($('#Height-inches1').val());
	  var heightSlab1 	 = parseFloat($('#Height-inches-slab1').val());
	
	var h = ((heightInches-heightInches1)-2.5);
    var slab = w+'" x '+h+'"';
    doorObj['Door Slab A,B'] = slab+" x "+1.5+'"';
	
    var c = getClearOpending(w);
	
	doorObj['Clear Opening'] = w1+'"';
	var v = getSlabSQFT(w,h,2);
	
	
	
	 var widthInches  	 = parseFloat($('#Width-inches1').val());
	   var width4ths=0;
	  if($('#Width-quarters1').val() == '0'){
		 var width4ths	   	 = parseFloat($('#Width-quarters1').val());
	  }else{
		if($('#Width-quarters1').val() != null){
		  var width4ths	   	 = parseFloat($('#Width-quarters1').val().replace('0.', ''));
		}
	  }
		
	  var heightInches 	 = parseFloat($('#Height-inches1').val());
	 
	  var height4ths   	 = 0;

	  if($('#Height-quarters1').val() == '0'){
		 var height4ths	   	 = parseFloat($('#Height-quarters1').val());
	  }else{
		if($('#Height-quarters1').val() != null){
		  var height4ths	   	 = parseFloat($('#Height-quarters1').val().replace('0.', ''));
		}
	  }
	  var height4ths1=0;
	  if($('#Height-quarters-slab1').val() == '0'){
		var type1 ='0';
		 var height4ths1	   	 = parseFloat($('#Height-quarters-slab1').val());
	  }else{
		var type1 ='1';
		if($('#Height-quarters-slab1').val() != null){
		  var height4ths1	   	 = parseFloat($('#Height-quarters-slab1').val().replace('0.', ''));
		}
	  }
	
	var h = heightInches+'.'+height4ths1;
    var slab = h+'"';
	
	
    doorObj['Finished Floor Allowance'] = slab;
	//doorObj['Slab Size Area'] = v+" SQ FT";
   // doorObj['Door Slab B'] = slab;
 }else if ($doorType.val() === 'single door') {
  
   doorObj['Door Slab'] = (widthInches-3)+'.'+width4ths+'" x '+(heightInches-2)+'.'+height4ths+'"';
	 var w = widthInches+"."+width4ths;
	  var h = heightInches+"."+height4ths;
	  var v = getSlabSQFT(w,h,1);
	//doorObj['Slab Size Area'] = v+" SQ FT";
   // doorObj['Door Slab B'] = slab;
 } else if ($doorType.val() === 'pivot door') {
	 console.log('ddd');
  	doorObj['Door Slab'] = (widthInches-3)+'.'+width4ths+'" x '+(heightInches-2)+'.'+height4ths+'"';
  } else {
    doorObj['Door Slab'] = (widthInches-3)+'.'+width4ths+'" x '+(heightInches-2)+'.'+height4ths+'"';
  }
  if(p_type !=''){
	  
	  doorObj['Closure'] = closure.val()+"-"+p_type;
  }else{
	  doorObj['Closure'] = closure.val();
  }
 
if ($doorType.val() === 'single door' ) {
	
	   var hinge		 = $('input[name="Hinge Finish"]:checked');
		doorObj['Hinge Frame'] = hinge.val();
		items.push({ id: hinge.data('id'), quantity: quantity, properties: {
		'Door ID': timestamp, 
		}
	  });
}
   
   if ($doorType.val() === 'barn-double-door' || $doorType.val() === 'barn-door'  ) {
	 
   }else{
	   
	   var $p_id =$('#p_id').val();
		if( $p_id == '8388498325810' ||  $p_id == '8398933918002' ){
		   var finishFrame = $('input[name="Frame Finish"]:checked');  
			doorObj["Frame Finish"] = finishFrame.val();
			items.push({
			id: finishFrame.data("id"),
			quantity: quantity,
			properties: {
			"Door ID": timestamp,
			"properties": doorObj,
			},
			});
			
		  
			var slabfinish = $('input[name="Slab Finish"]:checked');
			var color_pickeerr = $('input#color_pickeerr').val();
			//console.log(color_pickeerr+'color_pickeerr_value');     
			var box_name = $('input#box_name').val();
			
			doorObj["Slab Finish"] = slabfinish.val();
			 var premium_clr =$("div.slab_div.configItem  input[name='premium_clr']").val();
			var color_pickeerr = $('input#color_pickeerr').val();
			var colorPicker2 = $('#colorPicker2').val();
			var box_name = $('div.slab_div.configItem  input[name="box_name"]').val();
			if (premium_clr) {
			doorObj["Laminate Options"] = premium_clr;
			}

			if (color_pickeerr) {
			doorObj["Color"] = color_pickeerr;
			}

			if (colorPicker2) {
			doorObj["Color"] = colorPicker2;
			}

			if (box_name) {
			doorObj["Veneers Options"] = box_name;
			}
			items.push({
			  id: slabfinish.data("id"),
			  quantity: quantity,
			  properties: {
				"Door ID": timestamp,
				"properties": doorObj
			  },
			});
	  
		}
		
		var p_type4 = $("#closure_size").val();
		if (p_type4) {
		  doorObj["Pocket Size"] = p_type4;
		}
		
		
		if ($("#closure_size_id").val() != '') {
			let idToAdd = $("#closure_size_id").val();  
			
			 items.push({ id: idToAdd, quantity: 1, properties: {
				'Door ID': timestamp, 
				'Door Type':p_type4,
				}
			  });
		}
	  
	  
   }
   
   
 
  doorObj['Door Type'] = $doorType.val();
 
  items.push({ id: closure.data('id'), quantity: quantity, properties: {
    'Door ID': timestamp, 
	'Door Type':$doorType.val(),
    }
  });
  
  // items.push({ id: areaSqFt.data('id'), quantity: areaSqFt.val(), properties: {
    // 'Door ID': timestamp,
	// 'Door Type':$doorType.val(), 
    // }
  // });
  
  
 
  items.push({ id: variantId, quantity: quantity, properties: doorObj });
  console.log("items"+items);
  
  
  $.ajax({
    url: '/cart/add.js',
    type: 'post',
    dataType: 'json',
    data: { items: items },
    success: function(data, textStatus, jQxhr) {
    window.location.href = '/cart';
    },
    error: function(jqXhr, textStatus, errorThrown) {
      alert('There was a problem. Please try again');
    }
  });
}

$('[data-config-update]').on('change', function(evt) {
  var $qtyBtn    = $(this);
  var qty		 = $qtyBtn.val();
  var ids 		 = $qtyBtn.data('config-update').split(',');	
  var updatesObj = {};  
  
  $.each(ids, function(idx, val) {
    updatesObj[val] = qty;
  });
      
  $.ajax({
    url: '/cart/update.js',
    type: 'post',
    dataType: 'json',
    data: { updates: updatesObj },
    success: function(data, textStatus, jQxhr) {
      window.location.href = '/cart';
    },
    error: function(jqXhr, textStatus, errorThrown) {
      alert('There was a problem. Please try again');
    }
  });
  
  evt.preventDefault();
  evt.stopPropagation();
});

$('[data-config-remove]').on('click', function(evt) {
  evt.preventDefault();
  evt.stopPropagation();
  
  var $removeBtn = $(this);
  var ids 		 = $removeBtn.data('config-remove').split(',');	
  var updatesObj = {};
  
  $.each(ids, function(idx, val) {
    updatesObj[val] = 0;
  });
  
  $.ajax({
    url: '/cart/update.js',
    type: 'post',
    dataType: 'json',
    data: { updates: updatesObj },
    success: function(data, textStatus, jQxhr) {
      window.location.href = '/cart';
    },
    error: function(jqXhr, textStatus, errorThrown) {
      alert('There was a problem. Please try again');
     }
  });
});

$('[data-ruler-read-more] a').on('click', function(evt) {
  evt.preventDefault();
  
  var $div = $(this).closest('div');
  $div.hide();
  $div.next().show();
});

$('[data-ruler-read-less] a').on('click', function(evt) {
  evt.preventDefault();
  
  var $div = $(this).closest('div');
  
  $div.hide();
  $div.prev().show();
});
